import React, { useState } from "react";
import { getFaqData } from "./faqData";
import checkitout from "../../../images/checkitout.png";
import { useTranslation } from "react-i18next";

export default function Faq(props) {
    const { id, setSelectedFaq, highPriority=true } = props;

    const {t} = useTranslation("review_activity");
    const [opened, setOpened] = useState(false);
    const faqData = getFaqData(t);

    return (
      <div className="faq-line" onClick={onClick}>
        <div className="checkitout-wrapper">
          {!opened && highPriority && <img className="checkitout" src={checkitout} />}
        </div>
        <div key={id} className='faq-title'>
          {faqData[id].title}
        </div>
      </div>
    )
  
    function onClick() {
      setOpened(true);
      setSelectedFaq(id);
    }
  }